import { useEffect } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const useAmplitudeVisit = ({ page }) => {
  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, { page });
  }, []);
};

export default useAmplitudeVisit;
